export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "招标监管人员信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "用户名称：",
            type: "input",
            value: "yhmc",
            disabled: true,
          },
          {
            label: "真实姓名：",
            type: "input",
            value: "zsxm",
            disabled: true,
          },
          {
            label: "行政监督部门：",
            type: "select",
            value: "qgdm",
            disabled: true,
            queryParams: {
              url: "/zoneDepartment/DepartmentCombobox",
            },
          },
          {
            label: "是否显示同级单位权限：",
            value: "showSameAuditPowerFlag",
            type: "radio",
            required: true,
            option: [
              {
                label: "是",
                value: "1"
              },
              {
                label: "否",
                value: "0"
              }
            ],
            rule: {
              required: false,
              message: "请选择是否显示同级单位权限",
              trigger: "blur"
            },
          },
        ]
      },
      {
        title: "全部核验权限",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "nodeUserList",
            class: "formList",
          },
        ]
      },
    ];
  }
}
